import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styled, { css, keyframes } from 'styled-components';
const Group = styled.div `
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: -5px;
`;
const TabClick = keyframes `
  0% { transform: scale(1) }
  50% { transform: scale(0.9) }
  100% { transform: scale(1.07) }
`;
const Button = styled.button `
  padding: 11px 19px;
  border-radius: 4px;
  border: none;
  outline: none;
  font-size: 12px;
  letter-spacing: 0.1px;
  line-height: 14px;
  font-weight: normal;
  box-shadow:
    0 1px 3px rgba(53, 54, 56, 0.12),
    0 1px 2px rgba(53, 54, 56, 0.24);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  background: ${({ theme }) => theme.colors.grey01_2};
  color: ${({ theme }) => theme.colors.black_1};
  margin: 5px;
  ${({ animationStart }) => animationStart &&
    css `
      animation: ${TabClick} 250ms ease-in;
    `}
  &:disabled {
    opacity: 0.45;
  }
  &:not(:disabled) {
    cursor: ${({ active }) => (active ? 'default' : 'pointer')};
    ${({ active }) => active &&
    css `
        background: ${({ theme }) => theme.colors.grey00_5};
        color: ${({ theme }) => theme.colors.black_3};
        transform: scale(1.1);
        box-shadow:
          0 2px 6px rgba(53, 54, 56, 0.12),
          0 2px 4px rgba(53, 54, 56, 0.24);
      `}
  }
`;
const TabButton = ({ title, active, onClick, disabled, dataTestId }) => {
    const [animationStart, setAnimationStart] = React.useState(false);
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line no-restricted-syntax
    const handleClick = React.useCallback((evt) => {
        if (onClick) {
            onClick(evt);
            if (!active) {
                setAnimationStart(true);
            }
        }
    }, [onClick, setAnimationStart, active]);
    return (_jsx(Button, { active: active, onClick: handleClick, disabled: disabled, onAnimationEnd: () => setAnimationStart(false), animationStart: animationStart, type: 'button', "data-testid": dataTestId, children: title }));
};
const TabButtonMemo = React.memo(TabButton);
const TabButtonWrapper = (props) => _jsx(TabButtonMemo, { ...props });
TabButtonWrapper.Group = Group;
export default TabButtonWrapper;
